<h1>Çalışan/Başvuru Sahibi Kayıtları</h1>
<span>
  <button (click)="goInventorrecords()" class="btn btn-primary">
    Buluş Sahibi Kayıtları</button
  ><span>
    <button
      (click)="goCompanyrecords()"
      class="btn btn-danger"
      style="background-color: #d70040"
    >
      Başvuru Sahibi Kayıtları
    </button>
    <span>
      <button
        (click)="goAttorneyrecords()"
        class="btn btn-danger"
        style="background-color: #28384f"
      >
        Patent Vekili Kayıtları
      </button>
    </span>
    <span>
      <button
        (click)="goRDProjectrecords()"
        class="btn btn-primary"

      >
        AR-GE Kayıtları
      </button>
    </span>
  </span>
  <p></p>
  <p></p>
  <p></p>
  <p></p>
  <p></p>
  <p></p>
  <p></p>
  <p></p>
  <hr />
  <h1>Patent Kayıt Durumları</h1>
  <table>
    <thead>
      <th>Taslak Buluş sayısı</th>
      <th>Kabul Edilmiş Buluş Sayısı</th>
      <th>Karar Verilmiş Buluş Sayısı</th>
      <th>Toplam Buluş sayısı</th>
    </thead>
    <tbody>
      <td>{{ taslakBulusSay }}</td>
      <td>{{ kayitliBulusSay }}</td>
      <td>{{ kararVerilenBulusSay }}</td>
      <td>{{ toplamBulusSay }}</td>
    </tbody>
  </table>
  <hr />
  <br />
  <p></p>
  <p></p>
  <p></p>
  <p></p>
  <h1>Şilinmiş Veri kayıtları</h1>
  <input
    style="color: rgb(255, 0, 0)"
    class="form-control"
    class="icon"
    type="text"
    name="search"
    [(ngModel)]="searchText"
    autocomplete="off"
    placeholder="Dosya Bilgileri Üzerinden Arama Yapabilirsiniz"
  />
  <table class="tableFixHead">
    <thead>
      <th>Silen kişi</th>
      <th>Silinme tarihi</th>
      <th>Kayıt Türü</th>
      <th>Silinen Kayıt Detayı</th>
    </thead>
    <tbody>
      <tr
        *ngFor="let user of deletionRecords | filter: searchText; let i = index"
      >
        <ng-container *ngFor="let item of user">
          <td>{{ item.responsiblePerson[0] | json }}</td>
          <td>{{ item.responsiblePerson[1] | date: "dd/MM/yyyy" }}</td>
          <td>{{ item.area | json }}</td>
          <td>
            {{ item.detail }}
            <p></p>
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>
</span>
